import styled from 'styled-components';

export const Container = styled.div`
    padding: 0 0 10px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
`;

export const TitleRow = styled.div`
    width: 100%;
    height: 40px;
    min-height: 40px;
    padding: 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    cursor: pointer;
    background-color: #222;

    &.expanded {
        margin-bottom: 10px;
    }

    &:hover {
        background-color: #000;
    }
`;

export const Title = styled.div`
    color: #999;
    font-size: 14px;
    text-transform: uppercase;
    flex: 1;
    margin-left: 10px;
`;

export const Button = styled.div`
    border: 1px solid ${props => props.color};
    color: ${props => props.color};
    padding: 0 15px;
    height: 30px;
    min-height: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-top: 10px;
    transition: color .3s ease 0s, background-color .3s ease 0s;
    
    &:not(.disabled):hover {
        color: ${props => props.hoverColor || '#fff' };
        background-color: ${props => props.color};
    }

    &.disabled {
        cursor: default;
        opacity: .5;
    }

    &.horziontal {
        margin: 0 10px 0 0;

        &:last-child {
            margin: 0;
        }
    }
`;

export const NoItems = styled.div`
    color: #ccc;
    text-align: center;
    font-size: 14px;
    flex: 1;
    margin-top: 20px;
`;

export const Message = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    padding: 5px;
    position: relative;
    cursor: pointer;

    &:hover {
        background-color: #666;
    }
`;

export const MessageIcon = styled.div`
    width: 30px;
    height: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: #fff;
    border: 1px solid #0c0;
`;

export const UserName = styled.div`
    font-size: 14px;
    color: #fff;
    margin-left: 10px;
`;

export const Background = styled.div`
    background: rgba(0,0,0, 0.6);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
`;



export const Window = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    width: 220px;
    height: 350px;
    margin: -175px 0 0 -110px;
    background-color: #333;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: stretch;
    z-index: 101;
    border: 1px solid #777;
`;

export const WindowTitle = styled.div`
    width: 100%;
    height: 30px;
    min-height: 30px;
    color: #fff;
    padding: 0 10px;
    background-color: #444;
    display: flex;
    align-items: center;
`;

export const WindowContent = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    width: 100%;
    align-items: stretch;
    justify-content: stretch;
    padding: 10px;
`;

export const WindowButtons = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    padding: 20px;
    width: 100%;
    border-top: 1px solid #777;
`;

export const Label = styled.div`
    color: #999;
    margin: 0 0 5px;
    font-size: 16px;
`;

export const Input = styled.input.attrs(p => ({
    type: "password"
}))`
    width: 100%;
    border: 1px solid #777;
    background-color: #111;
    height: 25px;
    color: #fff;
    margin-bottom: 10px;
`;

export const Error = styled.div`
    width: 100%;
    border: 1px solid #f99;
    color: #f99;
    background-color: #600;
    margin-bottom: 10px;
    padding: 10px;
`;

